import { render, staticRenderFns } from "./PortalDetail.vue?vue&type=template&id=6e034994&scoped=true"
import script from "./PortalDetail.vue?vue&type=script&lang=js"
export * from "./PortalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e034994",
  null
  
)

export default component.exports